export default "__VITE_ASSET__DQ$T8G4T__"